import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-marketing-workshop',
  templateUrl: './digital-marketing-workshop.component.html',
  styleUrls: ['./digital-marketing-workshop.component.scss']
})
export class DigitalMarketingWorkshopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
